export const MCP_KEYS = {
  all: ['mcp'] as const,
  terms: () => [...MCP_KEYS.all, 'terms'] as const,
  orgStatus: () => [...MCP_KEYS.all, 'org-status'] as const,
  consentStatus: () => [...MCP_KEYS.all, 'consent-status'] as const,
  signedTerms: (acceptanceId: number | undefined) =>
    [...MCP_KEYS.all, 'signed-terms', acceptanceId] as const,
};
